import { render, staticRenderFns } from "./DrugPrices.vue?vue&type=template&id=7512d985&scoped=true&"
import script from "./DrugPrices.vue?vue&type=script&lang=js&"
export * from "./DrugPrices.vue?vue&type=script&lang=js&"
import style0 from "./DrugPrices.vue?vue&type=style&index=0&id=7512d985&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7512d985",
  null
  
)

export default component.exports